// Set of helper functions to facilitate wallet setup

import { ExternalProvider } from '@ethersproject/providers'
import { ChainId } from '@pancakeswap/sdk'
import { BAD_SRCS } from 'components/Logo/Logo'
import { BASE_BSC_SCAN_URLS } from 'config'
import { BASE_RPC_URLS, BSC_RPC_URLS, BSC_TESTNET_RPC_URLS, ETH_RPC_URLS, POLYGON_RPC_URLS } from '../config/constants/rpc'
import { rpc_urls } from 'config/constants/exchange'

const NETWORK_CONFIG = {
  [ChainId.BSC]: {
    name: 'Binance',
    scanURL: BASE_BSC_SCAN_URLS[ChainId.BSC],
    rpcUrls: rpc_urls[ChainId.BSC],
  },
  [ChainId.BSC_TESTNET]: {
    name: 'Binance Testnet',
    scanURL: BASE_BSC_SCAN_URLS[ChainId.BSC_TESTNET],
    rpcUrls: BSC_TESTNET_RPC_URLS,
  },
  // [ChainId.ETH]: {
  //   name: 'Ethereum',
  //   scanURL: BASE_BSC_SCAN_URLS[ChainId.ETH],
  //   rpcUrls: rpc_urls[ChainId.ETH],
  // },
  // [ChainId.ARB]: {
  //   name: 'Ethereum',
  //   scanURL: BASE_BSC_SCAN_URLS[ChainId.ARB],
  //   rpcUrls: rpc_urls[ChainId.ARB],
  // },
  // [ChainId.BASE]: {
  //   name: 'Ethereum',
  //   scanURL: BASE_BSC_SCAN_URLS[ChainId.BASE],
  //   rpcUrls: rpc_urls[ChainId.BASE],
  // },
  // [ChainId.BASE_SEPOLIA]: {
  //   name: 'Ethereum',
  //   scanURL: BASE_BSC_SCAN_URLS[ChainId.BASE_SEPOLIA],
  //   rpcUrls: BASE_SEPOLIA_RPC_URLS,
  // },
  //  [ChainId.POLYGON]: {
  //   name: 'Ethereum',
  //   scanURL: BASE_BSC_SCAN_URLS[ChainId.POLYGON],
  //   rpcUrls: rpc_urls[ChainId.POLYGON],
  // },
  //  [ChainId.DAN]: {
  //   name: 'Danny',
  //   scanURL: BASE_BSC_SCAN_URLS[ChainId.DAN],
  //   rpcUrls: rpc_urls[ChainId.DAN],
  // },
  //  [ChainId.DANNY]: {
  //   name: 'Danny',
  //   scanURL: BASE_BSC_SCAN_URLS[ChainId.DANNY],
  //   rpcUrls: rpc_urls[ChainId.DANNY],
  // },
}

/**
 * Prompt the user to add BSC as a network on Metamask, or switch to BSC if the wallet is on a different network
 * @returns {boolean} true if the setup succeeded, false otherwise
 */
export const setupNetwork = async (chainId?: number, externalProvider?: ExternalProvider) => {
  const provider = externalProvider || window.ethereum
  if (!NETWORK_CONFIG[chainId]) {
    console.error('Invalid chain id')
    return false
  }
  if (provider) {
    try {
      await provider.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: `0x${chainId.toString(16)}` }],
      })
      return true
    } catch (switchError) {
      if ((switchError as any)?.code === 4902) {
        try {
          await provider.request({
            method: 'wallet_addEthereumChain',
            params: [
              {
                chainId: `0x${chainId.toString(16)}`,
                chainName: NETWORK_CONFIG[chainId].name,
                nativeCurrency: {
                  name: 'ETH',
                  symbol: 'eth',
                  decimals: 18,
                },
                rpcUrls: NETWORK_CONFIG[chainId].rpcUrls,
                blockExplorerUrls: [`${NETWORK_CONFIG[chainId].scanURL}/`],
              },
            ],
          })
          return true
        } catch (error) {
          console.error('Failed to setup the network in Metamask:', error)
          return false
        }
      }
      return false
    }
  } else {
    console.error("Can't setup the Shibarium network on metamask because window.ethereum is undefined")
    return false
  }
}

/**
 * Prompt the user to add a custom token to metamask
 * @param tokenAddress
 * @param tokenSymbol
 * @param tokenDecimals
 * @returns {boolean} true if the token has been added, false otherwise
 */
export const registerToken = async (
  tokenAddress: string,
  tokenSymbol: string,
  tokenDecimals: number,
  tokenLogo?: string,
) => {
  // better leave this undefined for default image instead of broken image url
  const image = tokenLogo ? (BAD_SRCS[tokenLogo] ? undefined : tokenLogo) : undefined

  const tokenAdded = await window.ethereum.request({
    method: 'wallet_watchAsset',
    params: {
      type: 'ERC20',
      options: {
        address: tokenAddress,
        symbol: tokenSymbol,
        decimals: tokenDecimals,
        image,
      },
    },
  })

  return tokenAdded
}

export const canRegisterToken = () => typeof window !== 'undefined' && window?.ethereum?.isMetaMask
